import { useContext, useState } from "react";
import { ProcessContext } from "../../contexts/ProcessContext";
import { v4 as uuidv4 } from "uuid";
import { EVENTS_CONFIG } from "../../components/shared/sharedKernel/EventCatcher/config";
import {
  EVENT_TYPES,
  sendEventForEachChannelOfTypeActive,
} from "nemuru-components";

export const useEventDispatcher = () => {
  const {
    state: { loan },
  } = useContext(ProcessContext);
  const idParams = {
    loanId: loan?.id,
    borrowerId: loan?.borrower_id,
  };
  const [lastProgressEventIdState, setLastProgressEventId] = useState();
  const dispatchEvent = ({ name, type, payload }) => {
    const isEventAProgressSkip =
      type === EVENT_TYPES.progress && payload.status === "skipped";
    const newEventId = isEventAProgressSkip
      ? lastProgressEventIdState
      : uuidv4();
    if (type === EVENT_TYPES.progress) setLastProgressEventId(newEventId);
    idParams.event_id = newEventId;
    sendEventForEachChannelOfTypeActive({
      name,
      type,
      payload,
      idParams: { ...idParams, event_id: newEventId },
      config: EVENTS_CONFIG,
    });
  };

  return { dispatchEvent, lastProgressEventIdState };
};
